<template>
  <div class="component-form">
    <h1 class="form-title">Finalized Syllabus</h1>
    <p class="text mt-30">
      Please make the needed edits based on the feedback received on your Syllabus draft. When finished, please resubmit the sharing link (with editing enabled)
      to the SL Portal.
    </p>
    <Button class="btn-download mt-20" skin="grey" @click="handleClickDownload" v-if="showCheckWrap">Your current syllabus</Button>
    <p class="text bold big mt-30">Please paste the final syllabus sharing link here and click submit.</p>
    <div class="inp-wrap mt-20 large">
      <Textarea :counter="false" placeholder="" :value="value.link" @input="handleInput($event, 'link')" />
    </div>
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import { Button } from '../../../../components/form';
import Textarea from '../../../../components/form/Textarea/Prototype';
export default {
  name: 'FinalizedSyllabus',
  components: {
    Button,
    Textarea
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    },
    originData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    currentSyllabus() {
      let ret = '';
      if (this.originData && this.originData.syllabus_draft) {
        let syllabusDraft = this.originData.syllabus_draft;
        if (syllabusDraft.link && syllabusDraft.link !== '') {
          ret = syllabusDraft.link;
        }
      }
      return ret;
    },
    showCheckWrap() {
      return this.currentSyllabus && this.currentSyllabus !== '';
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    },
    handleClickDownload: function() {
      this.$windowOpen(this.currentSyllabus);
    }
  }
};
</script>
